import { normalizer } from "./smoother";
import gsap from "gsap";

export const contact = () => {
    const btn = document.querySelectorAll('.btn__contact');
    const body = document.querySelector('body');
    const modal = document.querySelector('.contact-modal');
    const overlay = modal.querySelector('.contact-modal__overlay-btn');
    const close = modal.querySelector('.contact-modal__close');
    const cursor = document.querySelector('.cursor');

    btn.forEach(e => {
        e.addEventListener('click', () => {
            gsap.set(modal, {
                display: 'flex',
                onComplete: () => {
                    setTimeout(() => {
                        body.classList.add('contact-modal-active');
                        body.classList.add('overflow-hidden');
                        normalizer(false);
                        document.querySelector('.wpcf7-form')?.classList.remove('d-none');
                    }, 1)
                }
            })
        })
    })
    
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' &&  body.classList.contains('contact-modal-active')) {
            body.classList.remove('contact-modal-active');
            body.classList.remove('overflow-hidden');
            (0,_smoother__WEBPACK_IMPORTED_MODULE_0__.normalizer)(true);
            cursor.classList.remove('cursor--color-invert');
        }
    });

    overlay.addEventListener('click', () => {
        body.classList.remove('contact-modal-active');
        body.classList.remove('overflow-hidden');
        normalizer(true);
        cursor.classList.remove('cursor--color-invert');
    })

    close.addEventListener('click', () => {
        body.classList.remove('contact-modal-active');
        body.classList.remove('overflow-hidden');
        normalizer(true);
        cursor.classList.remove('cursor--color-invert');
    })
    if( document.querySelector('.btn__contact') ){
        document.querySelector('.btn__contact').addEventListener('click',() => {
            document.querySelector('.success-message').classList.add('d-none');
        });
    }
    document.getElementById("contact_email_address") != null ? document.getElementById("contact_email_address").setAttribute('autocomplete','off') : '';
    document.getElementById("contact_full_name") != null ? document.getElementById("contact_full_name").setAttribute('autocomplete','off') : '';
    document.addEventListener('wpcf7submit', e => {
        if (e.detail.apiResponse.status === "mail_sent") {
            document.querySelector('.wpcf7-form').classList.add('d-none');
            document.querySelector('.success-message').classList.remove('d-none');
        }
    }, false);
}